import React from 'react';
import ReactDOM from 'react-dom';

import { Content } from './Content';

function main() {
  const location = window.location;
  const requestUrl = `${location.protocol}//${location.host}`;
  const postID = document.querySelector('meta#post-id').content;

  const container = document.getElementById('root');

  container &&
    ReactDOM.render(<Content request={`${requestUrl}/wp-json/wp/v2/pages/${postID}`} />, container);
}

export default main;
